// GoldAd.jsx
import React, { useMemo } from "react";
import { sponsors } from "../../constants/sponsors.js";

const norm = (v) => (v ?? "").trim().toLowerCase();

function getSponsorMatch({ sponsorId, country, city }) {
    const id = norm(sponsorId);
    if (!id) return null;

    const ctry = norm(country);
    const cty = norm(city);

    // 1) Exact match: id + country + city
    let match = sponsors.find(
        (s) =>
            norm(s.id) === id &&
            norm(s.country) === ctry &&
            norm(s.city) === cty
    );
    if (match) return match;

    // 2) Fallback: id + country only (if sponsor has no city)
    match = sponsors.find(
        (s) =>
            norm(s.id) === id &&
            norm(s.country) === ctry &&
            norm(s.city) === ""
    );
    if (match) return match;

    // 3) Fallback: id only (global sponsor with no country/city)
    match = sponsors.find(
        (s) =>
            norm(s.id) === id &&
            norm(s.country) === "" &&
            norm(s.city) === ""
    );

    return match ?? null;
}

export default function GoldAd({ sponsorId, selectedCountry, selectedCity }) {
    const sponsor = useMemo(
        () =>
            getSponsorMatch({
                sponsorId,
                country: selectedCountry,
                city: selectedCity,
            }),
        [sponsorId, selectedCountry, selectedCity]
    );

    if (!sponsor) return null;

    const { imageSrc, label, href } = sponsor;
    const Wrapper = href ? "a" : "div";

    return (
        <Wrapper
            href={href}
            target={href ? "_blank" : undefined}
            rel={href ? "noopener noreferrer" : undefined}
            className={`block max-w-sm mx-auto mb-12 ${href ? "cursor-pointer" : ""}`}
        >
            <div className="relative overflow-hidden rounded-2xl border border-pink-200 bg-white shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-full bg-white pt-6 pb-8 px-4">
                    <img
                        src={imageSrc}
                        alt={label || "Partner advertisement"}
                        className="mx-auto max-h-80 w-full object-contain hover:scale-105 transition-transform"
                    />
                </div>

                <div className="absolute bottom-2 left-0 right-0 text-center text-xs text-gray-500">
                    Paid advertisement – Local Business
                </div>
            </div>
        </Wrapper>
    );
}
